import { mapGetters, mapMutations } from 'vuex';
// needed for when we run on node versions lower than 15 in some CI environments
import { AbortController } from 'node-abort-controller';
import { setStorage } from '../../utilities/nojq/_localstorage.js';

let timer;
let fetchRequest;
let fetchAbort = new AbortController();
const abortFetch = () => {
    fetchAbort.abort();
    fetchAbort = new AbortController();
};

export default {
    name: 'mvtAutocompleteTag',
    inject: ['$eventBus'],
    emits: ['update:modelValue'],
    data() {
        return {
            delayLoad: 1,
            index: 0,
            searchText: '',
            fetchedTags: [],
            searchTags: [],
            isVisible: false,
            maxCount: 5,
        };
    },
    props: {
        modelValue: {
            type: Array,
            default: () => {
                return [];
            },
        },
        options: {
            type: Object,
            default: () => ({
                fixedTags: [],
                defaultTags: [],
                suggestedTags: [],
                placeholder: '',
            }),
        },
    },

    computed: {
        ...mapGetters('glb', ['glb', 'getTags', 'getRecentTags']),
        ...mapGetters('msp', ['msp']),
        getZipcode() {
            return this.msp.firstZipcode;
        },
        getDefaultTags() {
            let pool = this.options.defaultTags || [];
            if (this.fetchedTags?.length) {
                pool = this.fetchedTags;
            } else if (this.options.suggestedTags?.length) {
                pool = this.options.suggestedTags;
            }
            let visibleTags = this.isRentalFilter ? [] : pool.filter((e) => this.options.fixedTags.indexOf(e) === -1);
            let tags = [...this.options.fixedTags, ...visibleTags].filter((e) => this._value.indexOf(e) === -1).splice(0, 8);
            if (tags.length + this._value.length > 8) {
                // max 8 tags
                tags = tags.slice(0, 8 - this._value.length);
            }
            return tags;
        },
        _value: {
            get() {
                return this.modelValue;
            },
        },
        isRentalFilter() {
            return this.$parent.isRent;
        }
    },
    mounted() {
        $(document).on('click.autocompletetag.' + this.vnumber, () => {
            $(document).trigger('dom.autocompletetag.hide.' + this.vnumber);
        });
        $(document).on('dom.autocompletetag.hide.' + this.vnumber, this.hide);
        $(this.$el).on('click.autocompletetag.' + this.vnumber, (e) => {
            e.stopPropagation();
        });
        $(this.$refs.input).one('focus', () => {
            $(document).one('autocomplete.init', () => {
                this._getSuggestion();
                $(this.$refs.input).on('focus.autocompletetag.' + this.vnumber, () => {
                    this.show();
                    let displayText = this.searchText;
                    !displayText && this._getSuggestion();
                });
                $(this.$refs.input).on('keyup.autocompletetag.' + this.vnumber, (e) => {
                    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
                        return;
                    } else if (e.key === 'ArrowDown') {
                        return this.next();
                    } else if (e.key === 'ArrowUp') {
                        return this.prev();
                    } else if (e.key === 'Escape') {
                        return this.hide();
                    } else if (e.key === 'Enter') {
                        document.activeElement && document.activeElement.blur();
                        this.select(this.index);
                        return this.hide();
                    }
                });
                $(this.$refs.input).trigger('focus.autocompletetag.' + this.vnumber);
            });
            $(document).trigger('autocomplete.init');
        });
    },
    watch: {
        searchText(newVal, oldVal) {
            if (oldVal !== newVal && newVal.length > this.delayLoad) {
                if (timer) {
                    clearTimeout(timer);
                }
                timer = setTimeout(this._getSuggestion, 500);
            }
        },
        getZipcode(newVal, oldVal) {
            if (newVal && newVal !== oldVal) {
                this.refreshFetchedTags();
            }
        },
    },
    methods: {
        ...mapMutations('glb', ['setTag', 'setRecentTag', 'removeRecentTag']),
        /** Keyword chip text must not depend on glb.tags (async / client-only); keeps SSR and hydration aligned. */
        chipDisplayLabel(tag) {
            if (!tag) {
                return '';
            }
            return String(tag).replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
        },
        refreshFetchedTags() {
            if (this.glb.rentals) return;
            var params = {
                query: '',
                postalCode: this.getZipcode,
                size: 10,
            };
            this.fetchTags(params).then((data) => {
                this.fetchedTags = data;
            });
        },
        clear() {
            this.searchText = '';
            this.index = 0;
            this.searchTags = [];
        },
        removeDuplicates(arr) {
            return arr.filter((item, index) => arr.indexOf(item) === index);
        },
        reset() {
            this.hide();
            setTimeout(this.clear, 10);
        },
        select(i) {
            if (i >= 0) {
                this.index = i || 0;
            }
            var item = this.searchTags[this.index];
            this.add(item);
        },
        toggle(item) {
            if (this._value.indexOf(item) > -1) {
                this.remove(item);
            } else {
                this.add(item);
            }
        },
        add(item) {
            if (item) {
                if (this._value.findIndex((e) => e === item) === -1) {
                    this._value.push(item);
                    this.$emit('update:modelValue', this._value);
                    if (this.getTags) {
                        setStorage('tags', this.getTags);
                    }
                }
                let index = this.getRecentTags.findIndex((e) => e === item);
                if (index === -1) {
                    this.setRecentTag(item);
                    setStorage('recentlyViewedTags', this.getRecentTags);
                }
            }
            this.reset();
        },
        remove(item) {
            if (this._value.findIndex((e) => e === item) > -1) {
                this._value.splice(
                    this._value.findIndex((e) => e === item),
                    1
                );
                this.$emit('update:modelValue', this._value);
            }
            let index = this.getRecentTags.findIndex((e) => e === item);
            if (index > -1) {
                this.removeRecentTag(item);
                setStorage('recentlyViewedTags', this.getRecentTags);
            }
        },
        _mapping(data) {
            if (data && data.suggestions && data.suggestions.length) {
                var dict = data.suggestions.map((item) => {
                    var displayId = item.displayName.replace(/\s+/g, '_');
                    if (displayId && displayId.toLowerCase() !== item.id && !this.getTags[item.id]) {
                        this.setTag({ key: item.id, value: item.displayName });
                    }
                    return item.id;
                });
                return dict;
            }
            return [];
        },
        fetchTags(params) {
            if (fetchRequest && fetchRequest.state === 'pending') {
                abortFetch();
            }
            return new Promise((resolve) => {
                const urlParams = new URLSearchParams(params);
                fetchRequest = fetch(`${this.glb.appUrl}api/v/attribute/tags/?${urlParams}`, { signal: fetchAbort.signal })
                    .then((response) => response.json())
                    .then((res) => {
                        fetchRequest.state = 'complete';
                        var data = [];
                        if (res.status && res.status.code === 0) {
                            data = this._mapping(res.data);
                        }
                        resolve(data);
                    })
                    .catch(() => {
                        resolve([]);
                    });
                fetchRequest.state = 'pending';
            });
        },
        _getSuggestion() {
            var displayText = this.searchText;
            if (displayText && displayText.length > this.delayLoad) {
                var params = {
                    query: displayText,
                    postalCode: this.getZipcode,
                    size: this.maxCount,
                };
                this.fetchTags(params).then((data) => {
                    this.searchTags = data.filter((e) => this._value.findIndex((e2) => e2 === e) === -1).splice(0, this.maxCount);
                });
            } else {
                this.searchTags = this._getDefaultSuggestion().splice(0, this.maxCount);
            }
            this.index = -1;
        },
        _getDefaultSuggestion() {
            let visibleTags = this.removeDuplicates([...this.options.fixedTags]);
            let recentTags = this.getRecentTags.filter((tag) => visibleTags.indexOf(tag) === -1);
            return [...visibleTags, ...recentTags];
        },
        hide() {
            if (this.isVisible) {
                this.isVisible = false;
                $('#body').removeClass('autocomplete-tag-show');
                this.$emit('closed');
            }
        },
        show() {
            if (!this.isVisible) {
                this.isVisible = true;
                $('#body').addClass('autocomplete-tag-show');
            }
        },
        next() {
            if (this.index >= this.searchTags.length) {
                this.index = 0;
            } else {
                this.index += 1;
            }
        },
        prev() {
            if (this.index <= 0) {
                this.index = this.searchTags.length - 1;
            } else {
                this.index -= 1;
            }
        },
    },
    beforeUnmount() {
        $(document).off('click.autocompletetag.' + this.vnumber);
        $(document).off('dom.autocompletetag.hide.' + this.vnumber);
    },
};
